import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
/**
 * 定制化弹窗8 中国民航大学 poprelationForm=7
 * Tab: 简介 / 习语金句(xyjj) / 资源推荐(zytj) / 优秀作品(xsyxzp)
 * @date 2026-04-09
 */
import { handleHttp, getformListItemsdatas, isWx, locationHandlev2 } from "@/utils/utils";
import Pagination from "@/view/map/customv2/pagination";
import Swiper from "swiper";
import "swiper/css/swiper.css";
import VueAudio from "vue-audio";
// import 'vue-audio-player/dist/vueaudioplayer.css'

import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
export default {
  name: "popcomp8",
  data() {
    return {
      fid: this.$route.query.fid,
      popLeftArr: [{
        name: "简介",
        id: 0
      }, {
        name: "习语金句",
        id: 4
      }, {
        name: "资源推荐",
        id: 5
      }, {
        name: "优秀作品",
        id: 6
      }],
      popLeftIndex: 0,
      linkcontainerflag: false,
      iframeurl: "",
      infoList: [],
      videoitem: "",
      videoitemflag: false,
      daohangflag: true,
      viewer: null,
      audiodescflag: false,
      audiodesc: null,
      timer: null,
      structList: [],
      structLabel: {},
      structImgdefaultValues: {},
      showGood: false,
      xyjjList: [],
      xyjjTotal: 0,
      xyjjType: [],
      zytjList: [],
      zytjTotal: 0,
      zytjType: [],
      xsyxzpList: [],
      xsyxzpTotal: 0,
      currentPage: 1,
      currentItem: null,
      typeIndex: 0
    };
  },
  components: {
    VueAudio,
    Pagination
  },
  watch: {},
  created() {
    isWx().then(type => {
      this.daohangflag = type === "mini-wx" ? false : true;
    });
  },
  mounted() {
    this.$nextTick(() => {
      console.log(`this.$attrs.detail`, this.$attrs.detail);
      if (this.structList.length === 0) {
        this.pointStruct();
      } else {
        this.setLeftTitle();
      }
      const onlyid = this.$attrs.detail.onlyid;
      this.getXyjj(onlyid);
      this.getZytj(onlyid);
      this.getXsyxzp(onlyid);
      this.getOtherStruct('xyjj', 'xyjjType');
      this.getOtherStruct('zytj', 'zytjType');
      this.swiperEl = new Swiper(this.$refs.swipercontainer, {
        initialSlide: 0,
        slidesPerView: this.$attrs.isMobile ? 1 : 2.3,
        autoplay: true,
        speed: 500,
        spaceBetween: this.$attrs.isMobile ? 0 : 10,
        observeSlideChildren: true,
        observeParents: true,
        observer: true
      });
      this.initViewer();
    });
  },
  methods: {
    formatListData(res) {
      (res.dataList || []).forEach(item => {
        let itemformdata = item.formIdValueData || {};
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
        });
        item.itemformdata = itemformat;
      });
      return res;
    },
    getXyjj(onlyid = "", page = 1, type = '') {
      let forms = {
        deptId: this.$route.query.fid,
        formId: "xyjj",
        page: page,
        limit: 8,
        t: "6572c469e378a44d6061450af53fbfd0"
      };
      let searchStr = {
        model: 0,
        filters: [{
          model: 0,
          filters: [{
            alias: "xy_placeid",
            compt: "selectbox",
            express: "===",
            val: [onlyid]
          }]
        }]
      };
      if (type !== '' && type !== '全部') {
        searchStr.filters.push({
          model: 0,
          filters: [{
            alias: "classify",
            compt: "selectbox",
            express: "===",
            val: [type]
          }]
        });
      }
      if (onlyid) {
        forms.searchStr = encodeURI(JSON.stringify(searchStr));
      }
      this.$api.singleadvanceSearchv2(forms).then(res => {
        this.formatListData(res);
        this.xyjjList = res.dataList || [];
        this.xyjjTotal = res.totalPage;
      });
    },
    getZytj(onlyid = "", page = 1, type = '') {
      let forms = {
        deptId: this.$route.query.fid,
        formId: "zytj",
        page: page,
        limit: 8,
        t: "992128195069e5b7232570204dea769e"
      };
      let searchStr = {
        model: 0,
        filters: [{
          model: 0,
          filters: [{
            alias: "zy_placeid",
            compt: "selectbox",
            express: "===",
            val: [onlyid]
          }]
        }]
      };
      if (type !== '' && type !== '全部') {
        searchStr.filters.push({
          model: 0,
          filters: [{
            alias: "classify",
            compt: "selectbox",
            express: "===",
            val: [type]
          }]
        });
      }
      if (onlyid) {
        forms.searchStr = encodeURI(JSON.stringify(searchStr));
      }
      this.$api.singleadvanceSearchv2(forms).then(res => {
        this.formatListData(res);
        this.zytjList = res.dataList || [];
        this.zytjTotal = res.totalPage;
      });
    },
    getXsyxzp(onlyid = "", page = 1) {
      let forms = {
        deptId: this.$route.query.fid,
        formId: "xsyxzp",
        page: page,
        limit: 8,
        t: "ea0071355007a143190fbaf5b26554fbaa5084d3028db91d73d6a5f2391a6610"
      };
      let searchStr = {
        model: 0,
        filters: [{
          model: 0,
          filters: [{
            alias: "yxzp_placeid",
            compt: "selectbox",
            express: "===",
            val: [onlyid]
          }]
        }]
      };
      if (onlyid) {
        forms.searchStr = encodeURI(JSON.stringify(searchStr));
      }
      this.$api.singleadvanceSearchv2(forms).then(res => {
        this.formatListData(res);
        this.xsyxzpList = res.dataList || [];
        this.xsyxzpTotal = res.totalPage;
      });
    },
    toDetail(item) {
      this.showGood = true;
      this.currentItem = item;
      ['xy_content', 'zy_content', 'yxzp_content', 'xy_introduction', 'zy_introduction', 'yxzp_introduction'].forEach(key => {
        if (item[key]) {
          this.currentItem[key] = this.replaceIframeSrc(item[key], {
            removeLast: true
          });
        }
      });
    },
    replaceIframeSrc(html, options = {}) {
      // 设置默认选项
      const defaultOptions = {
        targetSrc: "insertVideo.html",
        replaceSrc: "https://noteyd.chaoxing.com/attachment/insertVideo.html",
        parentClass: "editor-iframe",
        removeLast: false // 新增选项：是否移除最后一个 editor-iframe
      };
      const opts = {
        ...defaultOptions,
        ...options
      };

      // 边界条件处理
      if (!html || typeof html !== "string") {
        console.warn("传入的 HTML 文本无效");
        return html;
      }
      try {
        // 创建临时 DOM 元素用于解析 HTML
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;

        // 用于存储替换数量、样式修改数量和移除数量的计数器
        let replacedCount = 0;
        let styledCount = 0;
        let removedCount = 0;

        // 查找所有包含指定类名的父元素
        const parentElements = tempDiv.querySelectorAll(`.${opts.parentClass}`);

        // 遍历每个父元素，处理其内部的 iframe
        parentElements.forEach(parent => {
          const iframes = Array.from(parent.querySelectorAll("iframe"));
          iframes.forEach(iframe => {
            // 检查内容是否包含错误页面文本

            // 检查 src 属性是否包含目标链接
            if (iframe.src && iframe.src.endsWith(opts.targetSrc) || iframe.src && iframe.src.endsWith("insertCloud.html")) {
              // 特殊处理：如果目标是 insertCloud.html，则删除该 iframe
              if (iframe.src.endsWith("insertCloud.html")) {
                // iframe.parentNode.removeChild(iframe);
                iframe.src = "https://noteyd.chaoxing.com/attachment/insertCloud.html";
                replacedCount++;
              }
              if (iframe.src.endsWith(opts.targetSrc)) {
                // iframe.parentNode.removeChild(iframe);
                iframe.src = opts.replaceSrc;
                replacedCount++;
                // 为 iframe 追加样式
                const originalStyle = iframe.getAttribute("style") || "";
                const newStyle = "width:95%;height:410px;";
                // 合并样式并避免重复添加
                if (!originalStyle.includes(newStyle)) {
                  iframe.setAttribute("style", `${newStyle} ${originalStyle}`);
                  styledCount++; // 增加样式修改计数器
                }
              }
              // 替换为新的链接
              replacedCount++;
              // console.log(`已替换 iframe 链接: ${iframe.src}`);
            }
          });
        });

        // 返回处理后的 HTML 文本
        return tempDiv.innerHTML;
      } catch (error) {
        console.error("处理 iframe 时出错:", error);
        return html;
      }
    },
    homeback() {
      this.showGood = false;
    },
    handlePageChange(newPage) {
      this.currentPage = newPage;
      const onlyid = this.$attrs.detail.onlyid;
      const typeTitle = this.popLeftIndex === 4 ? this.xyjjType[this.typeIndex] && this.xyjjType[this.typeIndex].title || '' : this.popLeftIndex === 5 ? this.zytjType[this.typeIndex] && this.zytjType[this.typeIndex].title || '' : '';
      if (this.popLeftIndex == 4) {
        this.getXyjj(onlyid, newPage, typeTitle);
      }
      if (this.popLeftIndex == 5) {
        this.getZytj(onlyid, newPage, typeTitle);
      }
      if (this.popLeftIndex == 6) {
        this.getXsyxzp(onlyid, newPage);
      }
    },
    // 统一换地址
    sethandleHttp(url) {
      return handleHttp(url);
    },
    // 关闭事件
    closePop() {
      this.showGood = false;
      this.$emit("closeHandle");
      this.popshowflag = false;
      this.popLeftIndex = 0;
      if (this.audiodescflag) {
        this.$refs.audiodesc.pause();
        this.audiodescflag = false;
      }
      this.closevideoItem();
    },
    closevideoItem() {
      this.videoitemflag = false;
      this.videoitem = "";
    },
    // 弹窗左边点击事件
    popLeftHandle(id) {
      this.popLeftIndex = id;
      this.showGood = false;
      this.typeIndex = 0;
    },
    // 返回事件
    goback() {
      this.linkcontainerflag = false;
      this.iframeurl = "";
    },
    goLocation(url) {
      locationHandlev2.call(this, this.$attrs.detail, url);
    },
    // 跳转
    goLink(url) {
      // 若选择打开新窗口处理
      if (this.$attrs.detail.linkTarget !== undefined && this.$attrs.detail.linkTarget === "是") {
        window.open(url);
      } else {
        this.linkcontainerflag = true;
        this.iframeurl = url;
      }
    },
    // 视频切换
    videoItemHandle(item) {
      this.videoitemflag = true;
      this.videoitem = this.popLeftIndex === 2 ? item : item.itemformdata;
    },
    initViewer() {
      this.$nextTick(() => {
        if (this.viewer) {
          this.viewer.destroy();
          this.viewer = null;
          return;
        }
        let that = this;
        this.viewer = new Viewer(document.querySelector(".swiper-wrapper"), {
          navbar: true,
          // 显示导航栏
          toolbar: true,
          // 显示工具栏
          title: false,
          viewed() {
            console.log(`this.$attrs.imgrotate`, that.$attrs.imgrotate);
            if (that.$attrs.imgrotate !== undefined && that.$attrs.imgrotate) that.viewer.rotateTo(90);
            document.querySelector(".viewer-container").classList.add(`fid${that.$route.query.fid}`);
          }
        });
      });
    },
    getAddress(val) {
      let data = val[0];
      let addressArr = ["country", "province", "city", "district", "street"];
      let str = "";
      addressArr.forEach(elem => {
        if (data[elem] && data[elem] !== undefined && data[elem] !== "") str += data[elem];
      });
      if (str === "" && data.address !== undefined) str = data.address;
      return str;
    },
    playaudiodesc() {
      this.audiodescflag = !this.audiodescflag;
      if (this.audiodescflag) {
        this.$refs.audiodesc.pause();
      } else {
        this.$refs.audiodesc.play().catch(error => {
          console.error("Play request was interrupted:", error);
        });
      }
    },
    /**
     * 获取地点管理表表单结构
     */
    pointStruct() {
      let params = {
        deptId: this.$route.query.fid,
        formId: 165054
      };
      this.$api.formStruct(params).then(res => {
        this.structList = JSON.parse(JSON.stringify(res));
        this.structList.forEach(elem => {
          if (elem.compt === "imagebox" && elem.field.values.length > 0) this.structImgdefaultValues[elem.alias] = elem.field.values[0].fileUrl;
          this.structLabel[elem.alias] = elem.label;
        });
        this.setLeftTitle();
        console.log(`this.structLabel`, this.structLabel);
        console.log(`this.structImgdefaultValues`, this.structImgdefaultValues);
      });
    },
    setLeftTitle() {
      let audioList = this.$attrs.detail.audio;
      if (audioList && audioList.length > 0) {
        let isHasaudio = this.popLeftArr.find(item => {
          return item.id === 3;
        });
        if (!isHasaudio) this.popLeftArr.push({
          name: this.structLabel.audio,
          id: 3
        });
      }
      let videoList = this.$attrs.detail.video;
      if (videoList && videoList.length > 0) {
        let isHasvideo = this.popLeftArr.find(item => {
          return item.id === 2;
        });
        if (!isHasvideo) this.popLeftArr.push({
          name: this.structLabel.video,
          id: 2
        });
      }
    },
    async getOtherStruct(formId, elem) {
      let params = {
        deptId: this.$route.query.fid,
        formId: formId
      };
      const resdata = await this.$api.formStruct(params);
      const structData = JSON.parse(JSON.stringify(resdata));
      const list = Array.isArray(structData) ? structData : structData.data || [];
      const typeData = list.find(item => {
        return item.alias === 'classify';
      });
      if (typeData && typeData.field && typeData.field.options) {
        this[elem] = [...typeData.field.options];
        this[elem].unshift({
          title: '全部'
        });
      } else {
        this[elem] = [];
      }
    },
    typeClick(item, index) {
      this.typeIndex = index;
      this.currentPage = 1;
      const onlyid = this.$attrs.detail.onlyid;
      if (this.popLeftIndex === 4) this.getXyjj(onlyid, 1, item.title);
      if (this.popLeftIndex === 5) this.getZytj(onlyid, 1, item.title);
    }
  }
};